// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';


// CUSTOM 
import { Formik, Form } from 'formik';
import Step from '@mui/material/Step';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { editCustomer, saveCustomer, storeGetDetailCustomer } from '../../../store/customer';
import { mapEditCustomerToApi } from './mappers';
import { SnackAlert } from '../../../components/SnackAlert';
import { MessagesDrawerRight } from '../../../components/MessagesDrawerRight';
import { Breadcrumbs, Button, Card, Divider, Typography } from '@mui/material';
import validationSchema from './formik/edit/validationSchema';
import formInitialValues from './formik/edit/formInitialValues';
import editCustomerFormModel from './formik/edit/editCustomerFormModel';
import { EditarDatosClientes } from './components/forms/EditarDatosClientes';
import { EditarModulosCliente } from './components/forms/EditarModulosCliente';
import { useResponseHandler } from '../../../hooks/useResponseHandler';
import { EditarModuloPermisosCustomer } from './components/EditarModuloPermisosCustomer';
// import { EditarModuloPermisosCustomer } from '../../components/EditarModuloPermisosCustomer';
// import { EditarModuloPermisosCustomer } from '../../components/EditarModuloPermisosCustomer';




export const EditCustomer = () => {

  const dispatch = useDispatch();

  // NAVIGATE 
  const navigate = useNavigate();
  const { id: customerId }: any = useParams();


  const { formId, formField } = editCustomerFormModel;

  const [data, setMsgErrors] = useState([]);
  const { handleResponse, ResponseComponents } = useResponseHandler();
  
  const [activeStep, setActiveStep] = useState(0);
  const [percentaje_c_Company, setPercentajeCCompany] = useState(2);
  const currentValidationSchema = validationSchema[activeStep];
  


  
  // useEffect(() => {
  //   detalleCustomer();
  // }, []);


  // const detalleCustomer = async() => {
  //     const response = await dispatch(storeGetDetailCustomer(customerId));
  //     if ( !response.ok ) {
  //       setMsgSnack({
  //           msg: response.message,
  //           status: 'error'
  //       });
  //       setAlertSnack(true);
  //       return false;
  //     }
  //   }



  // const steps: string[] = ['Informacion Basica', 'Permisos', 'Plan'];
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveStep(newValue);
  };

  const _handleSubmit = (values:any, actions:any) => {
      _submitForm(values, actions);
  }


  const  _renderStepContent = (steps: any) => {
    switch (steps) {
      case 0:
        return <EditarDatosClientes formField={formField} />;
      case 1:
        return <EditarModuloPermisosCustomer  />;
        // return <EditarModulosCliente  formField={formField} />;

        
    //   case 2:
    //     return <DetallePlan formField={formField} />;
    //   case 3:
      default: 
        return <div>Not Found</div>; 
    }
  }



  const _submitForm = async(values:any, actions:any) => {
  
    
    actions.setSubmitting(true);

    const mappedValues = mapEditCustomerToApi(values);
    const response = await dispatch( editCustomer(mappedValues, setPercentajeCCompany) );


    await handleResponse(response, 'Cliente Editado Con Exito', true);

    if (!response.ok) {
        actions.setSubmitting(false);
        return false;
    }

    if (response.ok) {
      setActiveStep(0);
      setTimeout(() => {
        navigate("/manager/clientes");
      }, 1500);
      actions.setSubmitting(false);
    }
  }




  return (
    <Box sx={{ width: '100%' }}>
     
    <MessagesDrawerRight data={data} title={''} />
  
  
    {ResponseComponents}
  
  

  <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Editar Cliente</Typography>
    <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
        <Link color="inherit" to="/manager/clientes">
          Listar Clientes
        </Link>
        <Typography color="textPrimary">Editar Cliente</Typography>
    </Breadcrumbs>
  <Divider sx={{ marginBottom: 3 }}/>
       
  
  
  <Tabs 
    value={activeStep} 
    onChange={handleTabChange} 
    sx={{ marginBottom: 3 }} 
    aria-label="edit customer tabs"
    textColor="primary"
    indicatorColor="primary"
  >
    <Tab icon={<ManageAccountsIcon />} iconPosition="start" label="Información Básica" sx={{ fontWeight: 600 }} />
    <Tab icon={<VpnKeyIcon />} iconPosition="start" label="Permisos" sx={{ fontWeight: 600 }} />
  </Tabs>

     <Formik
        initialValues={formInitialValues}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
      >
     <Card style={{ marginTop: 50,  padding: 20}}>
       <Form id={formId}>
         {_renderStepContent(activeStep)}
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: 25}}>
          { activeStep === 0 && (
            <Button
                style={{margin:5}}
                type="submit"
                variant="contained"
                color="success"
              >
                Actualizar Información Básica
            </Button>
          )}
        </div>
        </Form>
     </Card>
     
     </Formik>
</Box>
  )
}
